// if (!customElements.get("sticky-atc-bar")) {
//   customElements.define(
//     "sticky-atc-bar",
//     class StickyAtcBar extends HTMLElement {
//       constructor() {
//         super();
//         document.body.classList.add("sticky-atc-bar-enabled");

//         this.selectors = {
//           variantIdSelect: '[name="id"]',
//         };
//       }

//       get sectionId() {
//         return this.dataset.originalSection || this.dataset.section;
//       }

//       connectedCallback() {
//         this.productFormActions = document.querySelector(
//           ".f-main-product-form"
//         );
//         this.container = this.closest(".sticky-atc-bar");
//         this.mainProduct = document.querySelector(
//           "product-info[id^='MainProduct']"
//         );

//         this.variantData = this.getVariantData();
//         this.select = this.querySelector("select");

//         this.init();
//         this.select.addEventListener("change", () => {
//           const mainVariantPicker =
//             this.mainProduct.querySelector("variant-picker");
//           const selectedVariantId = this.querySelector(
//             this.selectors.variantIdSelect
//           ).value;
//           this.currentVariant = this.variantData.find(
//             (variant) => variant.id === Number(selectedVariantId)
//           );

//           if (mainVariantPicker) {
//             Array.from(
//               mainVariantPicker.querySelectorAll(
//                 "select, .variant-picker__option-values"
//               ),
//               (element, index) => {
//                 const variantOptionVal = this.currentVariant.options[index];
//                 switch (element.tagName) {
//                   case "SELECT":
//                     element.value = variantOptionVal;
//                     break;
//                   case "DIV":
//                     Array.from(element.querySelectorAll("input")).forEach(
//                       (radio) => {
//                         if (radio.value === variantOptionVal) {
//                           radio.checked = true;
//                         }
//                       }
//                     );
//                     break;
//                 }
//               }
//             );
//             mainVariantPicker.dispatchEvent(new Event("change"));
//           }

//           this.updatePrice();
//           this.updateButton(true, "", false);
//           if (!this.currentVariant) {
//             this.updateButton(true, "", true);
//           } else {
//             this.updateButton(
//               !this.currentVariant.available,
//               window.FoxThemeStrings.soldOut
//             );
//           }
//         });
//       }

//       getVariantData() {
//         this.variantData =
//           this.variantData ||
//           JSON.parse(
//             this.container.querySelector('[type="application/json"]')
//               .textContent
//           );
//         return this.variantData;
//       }

//       init() {
//         if (!this.productFormActions) {
//           this.container.classList.add("sticky-atc-bar--show");
//           return;
//         }
//         this.productId = this.dataset.productId;
//         const isMobile = window.matchMedia("(max-width: 639px)");

//         try {
//           // Chrome & Firefox
//           isMobile.addEventListener("change", this.checkDevice.bind(this));
//         } catch (err) {
//           try {
//             // Safari
//             isMobile.addListener(this.checkDevice.bind(this));
//           } catch (e2) {
//             console.error(e2);
//           }
//         }

//         // Initial check
//         this.checkDevice(isMobile);

//         const headerHeight = window.FoxThemeSettings.headerHeight || 80;
//         const rootMargin = `-${headerHeight}px 0px 0px 0px`;
//         this.observer = new IntersectionObserver(
//           (entries) => {
//             entries.forEach((entry) => {
//               const method = entry.intersectionRatio !== 1 ? "add" : "remove";
//               this.container.classList[method]("sticky-atc-bar--show");
//             });
//           },
//           { threshold: 1, rootMargin }
//         );
//         this.setObserveTarget();
//         this.syncWithMainProductForm();
//       }

//       setObserveTarget() {
//         this.observer.observe(this.productFormActions);
//         this.observeTarget = this.productFormActions;
//       }

//       checkDevice(e) {
//         setTimeout(() => {
//           const sectionHeight = this.clientHeight + "px";
//           document.documentElement.style.setProperty(
//             "--f-sticky-atc-bar-height",
//             sectionHeight
//           );
//         }, 100);
//       }

//       updateButton(disable = true, text, modifyClass = true) {
//         const productForm = document.getElementById(
//           "product-form-sticky-atc-bar"
//         );
//         if (!productForm) return;
//         const addButton = productForm.querySelector('[name="add"]');
//         const addButtonText = productForm.querySelector(
//           '[name="add"] > span:not(.f-icon)'
//         );

//         if (!addButton) return;

//         if (disable) {
//           addButton.setAttribute("disabled", "disabled");
//           if (text) addButtonText.textContent = text;
//         } else {
//           addButton.removeAttribute("disabled");
//           addButtonText.textContent = window.FoxThemeStrings.addToCart;
//         }
//       }

//       updateQuantityInput() {
//         const selectedVariantId = this.querySelector(
//           this.selectors.variantIdSelect
//         ).value;
//         this.currentVariant = this.variantData.find(
//           (variant) => variant.id === Number(selectedVariantId)
//         );
//         fetch(
//           `${this.getAttribute("data-url")}?variant=${
//             this.currentVariant.id
//           }&section_id=${this.sectionId}`
//         )
//           .then((response) => response.text())
//           .then((responseText) => {
//             const parsedHTML = new DOMParser().parseFromString(
//               responseText,
//               "text/html"
//             );
//             const quantity = document.querySelector(
//               `#QuantitySticky-${this.sectionId}`
//             );
//             const newQuantity = parsedHTML.querySelector(
//               `#QuantitySticky-${this.sectionId}`
//             );
//             if (newQuantity) {
//               quantity.innerHTML = newQuantity.innerHTML;
//             }
//           })
//           .catch((error) => {
//             console.error(error);
//           })
//           .finally(() => {});
//       }

//       updatePrice() {
//         const classes = {
//           onSale: "f-price--on-sale",
//           soldOut: "f-price--sold-out",
//         };
//         const selectors = {
//           priceWrapper: ".f-price",
//           salePrice: ".f-price-item--sale",
//           compareAtPrice: [".f-price-item--regular"],
//           unitPrice: ".f-price__unit",
//           saleBadge: ".f-price__badge-sale",
//           saleAmount: "[data-sale-value]",
//         };
//         const money_format = window.FoxThemeSettings.money_format;
//         const { priceWrapper, salePrice, unitPrice, compareAtPrice } =
//           queryDomNodes(selectors, this);

//         const { compare_at_price, price, unit_price_measurement } =
//           this.currentVariant;

//         const onSale = compare_at_price && compare_at_price > price;
//         const soldOut = !this.currentVariant.available;

//         if (onSale) {
//           priceWrapper.classList.add(classes.onSale);
//         } else {
//           priceWrapper.classList.remove(classes.onSale);
//         }

//         if (soldOut) {
//           priceWrapper.classList.add(classes.soldOut);
//         } else {
//           priceWrapper.classList.remove(classes.soldOut);
//         }

//         if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
//         if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

//         if (
//           compareAtPrice &&
//           compareAtPrice.length &&
//           compare_at_price > price
//         ) {
//           compareAtPrice.forEach(
//             (item) =>
//               (item.innerHTML = formatMoney(compare_at_price, money_format))
//           );
//         } else {
//           compareAtPrice.forEach(
//             (item) => (item.innerHTML = formatMoney(price, money_format))
//           );
//         }

//         if (unit_price_measurement && unitPrice) {
//           unitPrice.classList.remove("f-hidden");
//           const unitPriceContent = `<span>${formatMoney(
//             this.currentVariant.unit_price,
//             money_format
//           )}</span>/<span data-unit-price-base-unit>${getBaseUnit(
//             this.currentVariant
//           )}</span>`;
//           unitPrice.innerHTML = unitPriceContent;
//         } else {
//           unitPrice.classList.add("f-hidden");
//         }
//       }

//       syncWithMainProductForm() {
//         const variantInput = this.querySelector('[name="id"]');
//         window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
//           const isMainProduct =
//             evt.data.sectionId === this.mainProduct.dataset.section;
//           if (!isMainProduct) return;
//           this.currentVariant = evt.data.variant;
//           if (this.currentVariant) {
//             this.container.classList.remove("f-hidden");
//             variantInput.value = evt.data.variant.id;
//             this.updatePrice();
//             this.updateButton(true, "", false);
//             if (!evt.data.variant) {
//               this.updateButton(true, "", false);
//             } else {
//               this.updateButton(
//                 !evt.data.variant.available,
//                 window.FoxThemeStrings.soldOut
//               );
//             }
//           } else {
//             this.container.classList.add("f-hidden");
//           }

//           this.updateQuantityInput();
//         });
//       }
//     }
//   );
// }



if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add("sticky-atc-bar-enabled");

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };

        // Sync guard to avoid infinite loops when programmatically setting values
        this._isSyncingQuantity = false;

        // Config: how many pixels the user must scroll before the sticky observer is activated
        // You can tweak this value (e.g. 200, 300, 400) depending on preference
        this.minScrollOffsetToActivate = 200;
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          ".f-main-product-form"
        );
        this.container = this.closest(".sticky-atc-bar");
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']"
        );

        this.variantData = this.getVariantData();
        this.select = this.querySelector("select");

        this.init();

        // Variant select change on the sticky bar (keep current logic)
        this.select && this.select.addEventListener("change", () => {
          const mainVariantPicker =
            this.mainProduct && this.mainProduct.querySelector("variant-picker");
          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect
          ).value;
          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId)
          );

          if (mainVariantPicker) {
            Array.from(
              mainVariantPicker.querySelectorAll(
                "select, .variant-picker__option-values"
              ),
              (element, index) => {
                const variantOptionVal = this.currentVariant.options[index];
                switch (element.tagName) {
                  case "SELECT":
                    element.value = variantOptionVal;
                    break;
                  case "DIV":
                    Array.from(element.querySelectorAll("input")).forEach(
                      (radio) => {
                        if (radio.value === variantOptionVal) {
                          radio.checked = true;
                        }
                      }
                    );
                    break;
                }
              }
            );
            mainVariantPicker.dispatchEvent(new Event("change"));
          }

          this.updatePrice();
          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              window.FoxThemeStrings.soldOut
            );
          }

          // After variant change, fetch quantity html and rebind listeners
          this.updateQuantityInput();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector('[type="application/json"]')
              .textContent
          );
        return this.variantData;
      }

      init() {
         setTimeout(() => {
        if (!this.productFormActions) {
          this.container.classList.add("sticky-atc-bar--show");
          return;
        }
        this.productId = this.dataset.productId;
        const isMobile = window.matchMedia("(max-width: 639px)");

        try {
          // Chrome & Firefox
          isMobile.addEventListener("change", this.checkDevice.bind(this));
        } catch (err) {
          try {
            // Safari
            isMobile.addListener(this.checkDevice.bind(this));
          } catch (e2) {
            console.error(e2);
          }
        }

        // Initial check
        this.checkDevice(isMobile);

        const headerHeight = window.FoxThemeSettings.headerHeight || 80;
        const rootMargin = `-${headerHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? "add" : "remove";
              this.container.classList[method]("sticky-atc-bar--show");
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
         this.activateObserverOnScroll(); 
          this.setupQuantitySync();
          }, 4000);
      }

      // Activate observer only after user scrolled minScrollOffsetToActivate pixels
      activateObserverOnScroll() {
        this._startObserverOnScrollBound = this.startObserverOnScroll.bind(this);
        window.addEventListener("scroll", this._startObserverOnScrollBound, { passive: true });
        // Also call once in case the page is already scrolled (e.g. deep-linked)
        this.startObserverOnScroll();
      }

      startObserverOnScroll() {
        if (window.scrollY < this.minScrollOffsetToActivate) {
          // not ready yet
          return;
        }
        // user has scrolled enough — start observing and remove the listener
        if (!this.observerStarted) {
          this.observerStarted = true;
          window.removeEventListener("scroll", this._startObserverOnScrollBound);
          // if productFormActions is available, observe it; else try to set later
          if (this.productFormActions) {
            this.setObserveTarget();
          }
        }
      }

      setObserveTarget() {
        if (!this.observer || !this.productFormActions) return;
        try {
          this.observer.observe(this.productFormActions);
          this.observeTarget = this.productFormActions;
        } catch (e) {
          console.error("Observer could not observe target:", e);
        }
      }

      checkDevice(e) {
        setTimeout(() => {
          const sectionHeight = this.clientHeight + "px";
          document.documentElement.style.setProperty(
            "--f-sticky-atc-bar-height",
            sectionHeight
          );
        }, 100);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          "product-form-sticky-atc-bar"
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.FoxThemeStrings.addToCart;
        }
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect
        ).value;
        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(selectedVariantId)
        );
        fetch(
          `${this.getAttribute("data-url")}?variant=${
            this.currentVariant.id
          }&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );
            const newQuantity = parsedHTML.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );
            if (newQuantity && quantity) {
              // replace HTML and rebind quantity listeners
              quantity.innerHTML = newQuantity.innerHTML;
              this.attachStickyQuantityListeners();
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      /**********************
       * Quantity syncing
       *
       * - two-way sync between main product form quantity and sticky bar quantity
       * - is robust against programmatic changes and re-renders (we reattach listeners after HTML swap)
       **********************/
      setupQuantitySync() {
        // Attach listeners immediately if inputs exist
        this.attachStickyQuantityListeners();
        this.attachMainQuantityListener();

        // Also observe global changes just in case product-info re-renders inputs outside of our fetch flow
        // We'll use event capture to react early and prevent race conditions
        this._globalQuantityHandlerBound = this.handleGlobalQuantityChange.bind(this);
        document.addEventListener("change", this._globalQuantityHandlerBound, true);
        document.addEventListener("input", this._globalQuantityHandlerBound, true);
      }

      attachStickyQuantityListeners() {
        // Sticky quantity input is inside #QuantitySticky-{sectionId} wrapper
        const stickyWrapper = this.querySelector(`#QuantitySticky-${this.sectionId}`);
        if (!stickyWrapper) return;
        // find input inside wrapper
        const stickyInput = stickyWrapper.querySelector('input[name="quantity"], input[type="number"]');
        if (!stickyInput) return;
        // ensure no duplicate listeners
        stickyInput.removeEventListener('change', this._stickyQtyChangeBound);
        stickyInput.removeEventListener('input', this._stickyQtyChangeBound);

        this._stickyQtyChangeBound = this.handleStickyQuantityChange.bind(this);
        stickyInput.addEventListener('change', this._stickyQtyChangeBound);
        stickyInput.addEventListener('input', this._stickyQtyChangeBound);
      }

      attachMainQuantityListener() {
        if (!this.mainProduct) return;
        // main product quantity input can be inside quantity-input or be a plain input[name="quantity"]
        const mainInput = this.mainProduct.querySelector('quantity-input input, input[name="quantity"]');
        if (!mainInput) return;
        mainInput.removeEventListener('change', this._mainQtyChangeBound);
        mainInput.removeEventListener('input', this._mainQtyChangeBound);

        this._mainQtyChangeBound = this.handleMainQuantityChange.bind(this);
        mainInput.addEventListener('change', this._mainQtyChangeBound);
        mainInput.addEventListener('input', this._mainQtyChangeBound);
      }

      handleStickyQuantityChange(event) {
        if (this._isSyncingQuantity) return;
        const val = event.target.value;
        this._isSyncingQuantity = true;
        try {
          // update main product's quantity input
          const mainInput = this.mainProduct && this.mainProduct.querySelector('quantity-input input, input[name="quantity"]');
          if (mainInput) {
            mainInput.value = val;
            mainInput.dispatchEvent(new Event('input', { bubbles: true }));
            mainInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } finally {
          // small delay before allowing new programmatic changes
          setTimeout(() => (this._isSyncingQuantity = false), 50);
        }
      }

      handleMainQuantityChange(event) {
        if (this._isSyncingQuantity) return;
        const val = event.target.value;
        this._isSyncingQuantity = true;
        try {
          const stickyWrapper = this.querySelector(`#QuantitySticky-${this.sectionId}`);
          const stickyInput = stickyWrapper && stickyWrapper.querySelector('input[name="quantity"], input[type="number"]');
          if (stickyInput) {
            stickyInput.value = val;
            stickyInput.dispatchEvent(new Event('input', { bubbles: true }));
            stickyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } finally {
          setTimeout(() => (this._isSyncingQuantity = false), 50);
        }
      }

      // Global handler to catch quantity changes from other flows (e.g. product-info re-render)
      handleGlobalQuantityChange(e) {
        // ignore if target isn't a quantity input
        const target = e.target;
        if (!target) return;
        if (!target.matches('input[name="quantity"], quantity-input input, input[type="number"]')) return;

        // If change happened inside sticky element, handle as sticky change
        if (this.contains(target)) {
          this.handleStickyQuantityChange(e);
          return;
        }

        // If change happened within the main product area, handle as main change
        if (this.mainProduct && this.mainProduct.contains(target)) {
          this.handleMainQuantityChange(e);
          return;
        }
      }

      /**********************
       * End quantity syncing
       **********************/

      updatePrice() {
        const classes = {
          onSale: "f-price--on-sale",
          soldOut: "f-price--sold-out",
        };
        const selectors = {
          priceWrapper: ".f-price",
          salePrice: ".f-price-item--sale",
          compareAtPrice: [".f-price-item--regular"],
          unitPrice: ".f-price__unit",
          saleBadge: ".f-price__badge-sale",
          saleAmount: "[data-sale-value]",
        };
        const money_format = window.FoxThemeSettings.money_format;
        const { priceWrapper, salePrice, unitPrice, compareAtPrice } =
          queryDomNodes(selectors, this);

        const { compare_at_price, price, unit_price_measurement } =
          this.currentVariant || {};

        const onSale = compare_at_price && compare_at_price > price;
        const soldOut = this.currentVariant ? !this.currentVariant.available : false;

        if (onSale) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        if (soldOut) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
        if (salePrice && typeof price !== 'undefined') salePrice.innerHTML = formatMoney(price, money_format);

        if (
          compareAtPrice &&
          compareAtPrice.length &&
          compare_at_price > price
        ) {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML = formatMoney(compare_at_price, money_format))
          );
        } else if (typeof price !== 'undefined') {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = formatMoney(price, money_format))
          );
        }

        if (unit_price_measurement && unitPrice) {
          unitPrice.classList.remove("f-hidden");
          const unitPriceContent = `<span>${formatMoney(
            this.currentVariant.unit_price,
            money_format
          )}</span>/<span data-unit-price-base-unit>${getBaseUnit(
            this.currentVariant
          )}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPrice.classList.add("f-hidden");
        }
      }
// Call this when a variant change happens — hide sticky and require new scroll to re-activate
resetObserverAfterVariantChange() {
  // hide immediately
  if (this.container) {
    this.container.classList.remove("sticky-atc-bar--show");
    this.container.setAttribute("aria-hidden", "true");
  }

  // mark observer as not started so the IO callback won't toggle visibility
  this.observerStarted = false;

  // remove any existing observation to be safe
  try {
    if (this.observeTarget && this.observer) {
      this.observer.unobserve(this.observeTarget);
    }
  } catch (e) {
    // ignore
  }

  // Re-attach scroll listener (but avoid duplicating handlers)
  if (!this._startObserverOnScrollBound) {
    this._startObserverOnScrollBound = this.startObserverOnScroll.bind(this);
  }
  // remove first to avoid duplicates
  window.removeEventListener("scroll", this._startObserverOnScrollBound, { passive: true });
  window.addEventListener("scroll", this._startObserverOnScrollBound, { passive: true });
}

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          const isMainProduct =
            evt.data.sectionId === this.mainProduct.dataset.section;
          if (!isMainProduct) return;

           this.resetObserverAfterVariantChange();
           
          this.currentVariant = evt.data.variant;
          if (this.currentVariant) { 
            this.container.classList.remove("f-hidden"); 
            variantInput.value = evt.data.variant.id;
            this.updatePrice();
            this.updateButton(true, "", false);
            // important: update quantity input on variant change
            this.updateQuantityInput(); 
            if (!evt.data.variant) {
              this.updateButton(true, "", false);
            } else {
              this.updateButton(
                !evt.data.variant.available,
                window.FoxThemeStrings.soldOut
              );
            }
          } else {
            this.container.classList.add("f-hidden");
          }

          // ensure quantity is refreshed
          this.updateQuantityInput();
        });
      }
    }
  );
}
